import type { PlatformModule } from "@yatta/tenant-config";

export interface FlowProductModule {
  module: PlatformModule;
  name: string;
  description: string;
  path: string;
}

export const FLOW_PRODUCT_MODULES: readonly FlowProductModule[] = [
  {
    module: "funeral_assistance",
    name: "Planos funerários",
    description: "Venda e gestão de planos funerários como produto opcional do parceiro.",
    path: "/assistencia-funeraria",
  },
  {
    module: "telemedicine",
    name: "Telemedicina",
    description: "Oferta independente ou combinada, sem armazenar dados clínicos.",
    path: "/telemedicina",
  },
  {
    module: "vehicle_sales",
    name: "Venda de veículos",
    description: "Contratos de venda à vista ou parcelada e seus recebíveis.",
    path: "/vendas-veiculos",
  },
  {
    module: "vehicle_rentals",
    name: "Locação de veículos",
    description: "Contratos de locação, recorrência e cobrança de veículos.",
    path: "/locacoes-veiculos",
  },
  {
    module: "property_leases",
    name: "Locação de imóveis",
    description: "Contratos de locação imobiliária e respectivos aluguéis.",
    path: "/locacoes-imoveis",
  },
  {
    module: "software_contracts",
    name: "Contratos de software",
    description: "Licenças, assinaturas e serviços de software com cobrança recorrente.",
    path: "/contratos-software",
  },
];
